module.exports = __webpack_public_path__ + "static/media/Y4.2dc3f285.mp3";